import React, {useEffect, useState} from "react";
import {Alert, Backdrop, CircularProgress, Container, Grid, Paper, styled} from "@mui/material";
import {useLocation} from "react-router-dom";
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import Typography from "@mui/material/Typography";
import ServDescriptionPagePasteURLPanel from "./ServDescriptionPagePasteURLPanel";
import {useDispatch, useSelector} from "react-redux";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import ShowSnackbar from "../utils/ShowSnackbar";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";


const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledPaper = styled(Paper)(({theme}) => ({
    padding: theme.spacing(2),
    overflow: 'auto',
    boxShadow: '0 7px 20px #cccccc',
    minHeight: '200px'
}))
export default function ServDescriptionNewImportTask(props) {
    const location = useLocation();
    const path = location.pathname;
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({ open: false, msg: '', msgLv: ''});

    const { servDescriptionId, servDescriptionStatus } = useSelector(state => state.servDescriptionBatch);
    const { servDescriptionBatches, batchRefresh } = useSelector(state => state.allBatches);

    useEffect(() => {
        // getActiveBatchProgress("ImportValueSet", setLoading, setSnackbarMsg)
        //     .then( res => {
        //         res && dispatch(addServDescriptionBatch(res));
        //     })
        dispatch(getAllBatches());
    }, [batchRefresh])

    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={path} />
            <h3 className='title'>
                New ServDescription Import Task
            </h3>
            <Grid item xs={12} md={12} lg={12}>
                <h4>ServDescription URL</h4>
                <StyledPaper sx={{minHeight: '120px'}}>
                    <Typography gutterBottom>
                        Please enter the URL:
                    </Typography>
                    <ServDescriptionPagePasteURLPanel/>
                </StyledPaper>
            </Grid>
            <br/>
            <br/>
            <Grid item xs={12} md={12} lg={12}>
                <h4>ServDescription Import Progress</h4>
                <StyledPaper>
                    {/*{ servDescriptionStatus && <Alert severity={batchCurrentStatus[servDescriptionStatus].getStatus} icon={false}>{batchCurrentStatus[servDescriptionStatus].getMsg("ServDescription")}</Alert>}*/}
                    { servDescriptionBatches.length > 0 && servDescriptionBatches[0].status !== 'Init' &&
                        <Alert severity={batchCurrentStatus[servDescriptionBatches[0].status].getStatus} icon={false}>{batchCurrentStatus[servDescriptionBatches[0].status].getMsg("ServDescription")}</Alert>}
                    {/*{ servDescriptionId && servDescriptionStatus !== 'Completed' && servDescriptionStatus !== 'Cancelled' && servDescriptionStatus !== 'Failed' &&*/}
                    {/*    <ServDescriptionBatchProcessBar /> }*/}
                    { servDescriptionBatches.length > 0 && servDescriptionBatches[0].status !== 'Completed' && servDescriptionBatches[0].status !== 'Cancelled' && servDescriptionBatches[0].status !== 'Failed' &&
                        // <ServDescriptionBatchProcessBar batch={servDescriptionBatches[0]}/> }
                    <ExternalSourceBatchProgressBar batch={servDescriptionBatches[0]}/> }
                </StyledPaper>
            </Grid>
            {snackbarMsg.msg && snackbarMsg.msgLv &&
                <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            }

            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading }>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}